import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SectionHeader from 'components/SectionHeader';
import Loading from 'components/Loading';
import { Breadcrumb } from 'xland-ui';
import usePerformanceBreadcrumb from 'routes/Performance/hooks/usePerformanceBreadcrumb';
import { initializeKpiRelations } from 'routes/Performance/modules/actions';
import { ROUTE_STARTUP_PATH } from 'routes';
import PerformanceAddTabKpisStartup from './PerformanceAddTabKpisStartup';
import PerformanceAddTabTemplates from './PerformanceAddTabTemplates';
import PerformanceAddTabCustom from './PerformanceAddTabCustom';
import './styles.scss';

function PerformanceAdd(props) {
  const {
    lang,
    literals,
    literalsCommon,
    currency,
    match,
    startup,
    performance,
    fetchKpiRelations,
    postKpi,
    postKpisRelations,
  } = props;

  const { PERFORMANCE_ADD } = ROUTE_STARTUP_PATH;
  const { routes, nextRoutes } = usePerformanceBreadcrumb(PERFORMANCE_ADD, startup.id);

  useEffect(() => {
    initializeKpiRelations(fetchKpiRelations, performance, 'startup', match.params.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    { key: 'templates', name: literals.templates },
    { key: 'kpis', name: literals.kpis },
    { key: 'custom', name: literals.custom },
  ];

  if (!performance.loaded) {
    return <Loading mode='tool' />;
  }

  return (
    <div className='performanceAdd-wrapper'>
      <Breadcrumb routes={routes} nextRoutes={nextRoutes} />
      <SectionHeader tabs={tabs}>
        {tab => (
          <>
            {tab === 'templates' && (
              <PerformanceAddTabTemplates
                literals={literals}
                literalsCommon={literalsCommon}
                lang={lang}
                currency={currency}
                match={match}
                performance={performance}
                postKpisRelations={postKpisRelations}
                startup={startup}
              />
            )}
            {tab === 'kpis' && (
              <PerformanceAddTabKpisStartup
                literals={literals}
                literalsCommon={literalsCommon}
                lang={lang}
                currency={currency}
                match={match}
                startup={startup}
                performance={performance}
                postKpi={postKpi}
                postKpisRelations={postKpisRelations}
              />
            )}
            {tab === 'custom' && (
              <PerformanceAddTabCustom
                match={match}
                onSubmit={postKpi}
                literals={literals}
                literalsCommon={literalsCommon}
                startup={startup}
                lang={lang}
              />
            )}
          </>
        )}
      </SectionHeader>
    </div>
  );
}

PerformanceAdd.propTypes = {
  lang: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  performance: PropTypes.object.isRequired,
  fetchKpiRelations: PropTypes.func.isRequired,
  postKpi: PropTypes.func.isRequired,
  postKpisRelations: PropTypes.func.isRequired,
  startup: PropTypes.object.isRequired,
};

export default PerformanceAdd;
